import Vue from 'vue';

/**
 * Responsible for all HTTP requests.
 */
const http = {

  request(method, url, params = null, data = null, successCb = null, errorCb = null, headers = null, responseType = null) {
    Vue.axios.request({
      url,
      params,
      data,
      method: method.toLowerCase(),
      headers,
      responseType,
    }).then(successCb).catch(errorCb);
  },

  get(url, params, successCb = null, errorCb = null) {
    return this.request('get', url, params, null, successCb, errorCb);
  },

  post(url, data, successCb = null, errorCb = null, headers = null) {
    return this.request('post', url, null, data, successCb, errorCb, headers);
  },

  put(url, data, successCb = null, errorCb = null, headers = null) {
    return this.request('put', url, null, data, successCb, errorCb, headers);
  },

  patch(url, data, successCb = null, errorCb = null, headers = null) {
    return this.request('patch', url, null, data, successCb, errorCb, headers);
  },

  delete(url, data = {}, successCb = null, errorCb = null) {
    return this.request('delete', url, null, data, successCb, errorCb);
  },

  defaultError(error) {
    const text = error ? error.toString() : 'Error';
    const status = error.response ? error.response.status : '503';
    const data = error.response ? error.response.data : 'The server is currently unable to handle the request due to a temporary overloading or maintenance of the server.';
    return {
      text,
      status,
      data,
    };
  },

  /**
   * Init the service.
   */
  init() {
    // Intercept the request to make sure the token is injected into the header.
    // Vue.axios.interceptors.request.use((config) => {
    //   // config.headers.Authorization = `Bearer ${ls.get('jwt-token')}`
    //   config.headers.Authorization = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyZXF1ZXN0ZXJfaWQiOjMsImlhdCI6MTQ4NzM3ODg2NX0.B1v3bPCI1MrWHo4Q1ngG7cQU2tRkgX1ub5Ad8Xs5E-o';
    //   return config;
    // });
  },
};

export { http };



// WEBPACK FOOTER //
// ./src/services/http.js